<template>
    <div class="grid grid-cols-2 gap-2 sm:grid-cols-4">
        <button
            v-for="option in options"
            :key="option.value"
            type="button"
            class="min-h-[48px] rounded-xl border px-3 py-2 text-sm font-semibold transition-all"
            :class="modelValue === option.value ? colors(option.color).active : colors(option.color).inactive"
            @click="$emit('update:modelValue', option.value)"
        >
            {{ option.title }}
        </button>
    </div>
</template>

<script>
const COLOR_CLASSES = {
    gray: {
        active: 'border-cyan-600 bg-cyan-600 text-white shadow-sm',
        inactive: 'border-gray-200 bg-white text-gray-600 hover:border-cyan-300 hover:bg-cyan-50'
    },
    emerald: {
        active: 'border-emerald-500 bg-emerald-500 text-white shadow-sm',
        inactive: 'border-emerald-200 bg-white text-emerald-700 hover:bg-emerald-50'
    },
    amber: {
        active: 'border-amber-400 bg-amber-400 text-white shadow-sm',
        inactive: 'border-amber-200 bg-white text-amber-700 hover:bg-amber-50'
    },
    orange: {
        active: 'border-orange-500 bg-orange-500 text-white shadow-sm',
        inactive: 'border-orange-200 bg-white text-orange-700 hover:bg-orange-50'
    },
    red: {
        active: 'border-red-600 bg-red-600 text-white shadow-sm',
        inactive: 'border-red-200 bg-white text-red-700 hover:bg-red-50'
    }
};

export default {
    name: 'BaseButtonGroup',
    props: {
        options: {
            type: Array,
            required: true
        },
        modelValue: {
            type: [String, Number],
            default: null
        }
    },
    emits: ['update:modelValue'],
    setup() {
        function colors(color) {
            return COLOR_CLASSES[color] || COLOR_CLASSES.gray;
        }

        return { colors };
    }
}
</script>
